export default __webpack_public_path__ + "static/img_welfare_2@2x-ef1b2ab6f93e0def3b667632b243d475.jpg";